import { useState, useRef, useEffect } from 'react'

interface UserProfileDropdownProps {
  displayName: string | null
  email: string | null
  onSignOut: () => void
}

export function UserProfileDropdown({ displayName, email, onSignOut }: UserProfileDropdownProps) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  const name = displayName || email || 'User'
  const initial = name.charAt(0).toUpperCase()

  return (
    <div className="user-profile" ref={dropdownRef}>
      <button
        className="user-profile-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-haspopup="true"
        type="button"
      >
        <span className="user-profile-avatar">{initial}</span>
        <span className="user-profile-name">{name}</span>
      </button>

      {isOpen && (
        <div className="user-profile-dropdown">
          <div className="user-profile-info">
            <span className="user-profile-fullname">{name}</span>
            {email && <span className="user-profile-email">{email}</span>}
          </div>
          <div className="user-profile-divider" />
          <button
            className="user-profile-signout"
            onClick={() => {
              setIsOpen(false)
              onSignOut()
            }}
            type="button"
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  )
}
